module.exports = __webpack_public_path__ + "img/89ed91a.png";